import React, { createContext, useState, useContext } from 'react';
import Loader from '../components/Loader';

const LoadingContext = createContext();

export const LoadingProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState(null);
  return (
    <LoadingContext.Provider value={{ isLoading, setIsLoading, loadingMessage, setLoadingMessage }}>
      {children}
      <Loader isLoading={isLoading} loadingMessage={loadingMessage} />
    </LoadingContext.Provider>
  );
};

export const useLoading = () => useContext(LoadingContext);